import * as React from 'react';
import {styled} from '../../utils';
import {TextProps} from './types';

const chooseColor = (color: string, preset: {primary: string; secondary: string}) => {
  switch (color) {
    case 'primary':
      return preset.primary;
    case 'secondary':
      return preset.secondary;
    default:
      return color;
  }
};

const Root = styled('span')<TextProps>(
  ({color, fontFamily, fontSize, fontWeight, lineHeight, letterSpacing, upcase, theme}) => ({
    color: color ? chooseColor(color, theme.color) : undefined,
    fontFamily: fontFamily || theme.fontFamily.base,
    fontSize: fontSize || theme.fontSize.base,
    fontWeight,
    lineHeight,
    letterSpacing,
    textTransform: upcase ? 'uppercase' : undefined
  })
);

export default class Text extends React.Component<TextProps, {}> {
  public render() {
    const {withComponent, ...restProps} = this.props;
    const Component = withComponent ? Root.withComponent(withComponent as React.ComponentType) : Root;

    return <Component {...restProps} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Text/Text.tsx